import { Component } from '@angular/core';

export class Idioma { 
    nombre:string;
    porcentaje:number;

    // Constructor para generar un Idioma
    constructor(nombre?:string, porcentaje?:number){
        this.nombre = nombre;
        this.porcentaje = porcentaje;
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/models/idioma.ts